import { l } from '@manychat/manyui'

import { TikTokAdAppType } from 'shared/api/requests/integrations/tiktokAds/types'

export const getTikTokAdsTriggerSubtitleByAppType = (appType: TikTokAdAppType | null) => {
  const subtitle = (channel: string) => l.translate('Through {channel}', { channel })
  switch (appType) {
    case TikTokAdAppType.MESSENGER:
      return subtitle('Messenger')
    case TikTokAdAppType.WHATSAPP:
      return subtitle('WhatsApp')
    default:
      return l.translate('Through Instant Messenger apps')
  }
}
